import {makeBFFApiUrl} from 'main/factories/http';

import {GetConciergeUrl} from 'domain/usecases/private/home/concierge';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetConciergeUrl} from 'data/usecases/private/home/concierge';
import {ConciergeEndPoint} from '../../endpoints';

export const makeGetConciergeUrl = (): GetConciergeUrl =>
	new RemoteGetConciergeUrl(
		makeBFFApiUrl(ConciergeEndPoint.url),
		makeAuthorizeHttpClientDecorator(),
	);
